import executeQuery from "#lib/db"
import crypto from "crypto"
import jwt from "jsonwebtoken"

import { User } from "#types"

interface UserLogin {
	email: string
	password: string
}

export const getUser = async ({ email, password }: UserLogin) => {
	const encryptedPassword = crypto.createHash("sha256").update(password).digest("hex")

	const query = `select * from users where email='${email}' and password='${encryptedPassword}'`

	const user: User[] = await executeQuery({
		query,
	})

	if (user.length === 0) {
		// no user found
		return null
	} else {
		const token = jwt.sign({ userID: user[0].userID, role: "admin", level: 2 }, "secret-key")

		return {
			userID: user[0].userID,
			username: user[0].username,
			token,
		}
	}
}
